import { useEffect, type Dispatch, type SetStateAction } from "react"
import { useSearchParams } from "next/navigation"

import { ALGOLIA_TRACK_QUERY_PARAM } from "~/components/shared/AlgoliaAnalyticsEvents/index.client"

export function AlgoliaConversionTracker({
  algoliaConversationState,
  setAlgoliaConversationState,
}: {
  algoliaConversationState: boolean
  setAlgoliaConversationState: Dispatch<SetStateAction<boolean>>
}) {
  const params = useSearchParams()
  const trackAsAlgoliaConversion = params.get(ALGOLIA_TRACK_QUERY_PARAM) === "1"

  useEffect(() => {
    if (algoliaConversationState !== trackAsAlgoliaConversion) {
      setAlgoliaConversationState(trackAsAlgoliaConversion)
    }
  }, [trackAsAlgoliaConversion])

  return null
}
